/* Before/after comparison slider: arms at 10%, sweeps to 50% on first view,
   then tracks pointer drags and arrow keys. The sweep transition lives on the
   `is-animating` class; dragging removes it so the clip follows the pointer. */
class ImageCompare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.image-comparison__button');
    if (!this.button) return;

    this.classList.add('is-animating');
    this.setPercent(10);

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.setPercent(50);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(this);

    this.addEventListener('pointerdown', (event) => {
      if (event.target.closest('a')) return;
      this.classList.remove('is-animating');
      this.dragging = true;
      this.setPointerCapture(event.pointerId);
      this.track(event);
    });
    this.addEventListener('pointermove', (event) => {
      if (this.dragging) this.track(event);
    });
    ['pointerup', 'pointercancel'].forEach((type) => {
      this.addEventListener(type, () => {
        this.dragging = false;
      });
    });

    this.button.addEventListener('keydown', (event) => {
      const step = { ArrowLeft: -5, ArrowRight: 5, Home: -100, End: 100 }[event.key];
      if (step === undefined) return;
      event.preventDefault();
      this.classList.remove('is-animating');
      this.setPercent(Math.min(100, Math.max(0, this.percent + step)));
    });
  }

  track(event) {
    const rect = this.getBoundingClientRect();
    this.setPercent(((event.clientX - rect.left) / rect.width) * 100);
  }

  setPercent(value) {
    this.percent = Math.min(100, Math.max(0, value));
    this.style.setProperty('--percent', this.percent + '%');
    this.button?.setAttribute('aria-valuenow', String(Math.round(this.percent)));
  }
}

if (!customElements.get('image-compare')) {
  customElements.define('image-compare', ImageCompare);
}
